

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './DashTest.css';
import Header from '../sharedFiles/header/header';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getCartItemApi, getItemGroup } from '../APIServices/ItemPageService/ItemPageThunk';
import { toast, ToastContainer } from 'react-toastify';
import { GetHistory, GetSQHistory } from '../APIServices/HistoryService/HistoryThunk';
import { GetAdversitment, GetCustomerMaster, Getoffers } from '../APIServices/CustomerMasterService/CustomerMasterThunk';
import SpinnerLoader from '../sharedFiles/loader/spinnerLoader';
import { getDecryptedUser } from '../itemPage/ItemPageShared/ItemUtils';
import DashboardSidebar from './SideBar/dashboardSideBar';
import CustomerDashboardCards from './Card/CustomerDashboardCards ';
import { COLORS, EMPTY_COLOR, EMPTY_DATA, generateAgeingData, generateStepperItems, getTotalValue } from './dashboardUtilts';
import AgingAnalysisCard from './AgingCard/agingCard';
import MonthlyComparisonChart from './barChart/barchart';
import AdvertisementModel from './Advertisement/advertisementModel';
import RunningBanner from '../sharedFiles/banners/runningBanners';
const DashboardTest = () => {
  const dispatch = useDispatch();
  const userData = getDecryptedUser();
  const location = useLocation();
  const [imagechange, setImagechange] = useState(false);
  const navigate = useNavigate();
  const [customer, setCustomer] = useState(null);
  const successMessage = localStorage.getItem('successMessage');
  const { loading: { GetCustMaster: isCustomerLoading, AdversitmentImage: isAdversitmentImage }, error: { GetCustMasterError, AdversitmentImageError }, GetCustMaster, AdversitmentImage, Getoffersdata } = useSelector((state) => state.CustomerMaster);
  const { loading: { SqHistory: isSqHistoryLoading }, error: { SqHistoryError }, history } = useSelector((state) => state.history);
  const { loading: { GetItemGrp: isItemGrpLoading }, error: { GetItemGrpError, GetCartItmError }, GetItemGrp } = useSelector((state) => state.itemPage);
  const [callInProgress, setCallInProgress] = useState(
    { itemPage: false, fetchSQHistory: false, fetchCustomer: false, fetchAdImage: false });
  useEffect(() => {
    if (GetCustMaster?.getCustomerMasters?.length > 0) {
      setCustomer(GetCustMaster.getCustomerMasters[0]);
    } else if (!GetCustMaster) {
      dispatch(GetCustomerMaster());
    }
  }, [GetCustMaster, dispatch]);
  useEffect(() => {
    if (!Getoffersdata) {
      dispatch(Getoffers());
    }
    if (!AdversitmentImage) {
      const showAd = !location?.state?.showAd ?? true;
      setImagechange(showAd);
      dispatch(GetAdversitment());
    }
  }, [Getoffersdata, AdversitmentImage, location?.state?.showAd, dispatch]);
  
  console.log("AdversitmentImage", isAdversitmentImage);

  const isLoading = () => {
    return (
      isSqHistoryLoading ||
      isItemGrpLoading ||
      isCustomerLoading ||
      isAdversitmentImage
    );
  };
  //***********This for show the login success message ***********/
  useEffect(() => {
    if (successMessage) {
      localStorage.removeItem('successMessage');
      Swal.fire({
        position: "center",
        icon: "success",
        title: successMessage,
        showConfirmButton: false,
        timer: 2000
      });
    }
  }, [successMessage]);
  //********** This is for all get the itemgroup, item and cart item in intial load ******/

  const fetchData = async () => {
    if (!GetItemGrp) {
      await Promise.all([
        dispatch(getItemGroup()),
        dispatch(getCartItemApi())
      ]);
      setCallInProgress({ ...callInProgress, itemPage: true });
    }
  };
  useEffect(() => {
    fetchData();
  }, [dispatch]);
  //********** This is for all get the itemgroup, item and cart item when trigger a place order button ******/ 
  const handlePlaceOrder = async () => {
    if (GetItemGrp) {
      navigate('/ItemPage');
    } else {
      console.log("API trigger");
      await Promise.all
        (fetchData())
        .then(() => {
          navigate('/ItemPage');
        })
        .catch((error) => {
        });
    }
  };
  const errorShowing = (error) => {
    const errorss = error;
    const status = errorss.errorCode;
    const errormessages = errorss.errorMessage;
    if (status) {
      toast.error(errormessages);
    } else {
      toast.error("Network Error");
    }
  }
  const batchChecker = () => {
    if (callInProgress.fetchAdImage && AdversitmentImage) {
      // const errorss = AdversitmentImageError;
      // console.log("errorss",errorss);
      setCallInProgress({ ...callInProgress, fetchAdImage: false });
      // errorShowing(errorss);
    }
    if (callInProgress.itemPage && (GetItemGrpError || GetCartItmError)) {
      const errorss = (GetItemGrpError || GetCartItmError);
      setCallInProgress({ ...callInProgress, itemPage: false });
      errorShowing(errorss);
    }
    if (callInProgress.fetchCustomer && GetCustMasterError) {
      const errorss = GetCustMasterError;
      setCallInProgress({ ...callInProgress, fetchCustomer: false });
      errorShowing(errorss);
    }

  }

  useEffect(() => {
    batchChecker();
  }, [GetItemGrp, GetCustMaster, AdversitmentImage, callInProgress]);

  //********* This is for a handle a outgoing payment trigger **********/
  const handleReport = () => {
    navigate('/Reports');
  }

  const handleHistory = async () => {
    if (history) {
      setCallInProgress({ ...callInProgress, fetchSQHistory: true });
      await dispatch(GetHistory({ docType: 'Quote' }));
    }
    navigate('/orderHistory')
  };

  const ageingData = generateAgeingData(customer);
  const totalValue = getTotalValue(ageingData);
  const showEmptyGrey = totalValue === 0;
  const items = generateStepperItems(ageingData);
  const [adOpen, setAdOpen] = React.useState(location?.state?.showAd ? true : false);
  // const [adOpen, setAdOpen] = React.useState(true);

  const handlecloseAd = () => {
    setAdOpen(false);
  }
  const handleShowAdd = async () => {
    setCallInProgress({ ...callInProgress, fetchAdImage: true });
    await dispatch(GetAdversitment())
    setAdOpen(true);
    setImagechange(true)
  }
  return (
    <div className="layout-container">
      <Header />
      <DashboardSidebar
        onPlaceOrder={handlePlaceOrder}
        onReport={handleReport}
        onHistory={handleHistory}
        onshowAd={handleShowAdd} />
      <AdvertisementModel open={adOpen} onClose={handlecloseAd} offautoImage={imagechange} />
      {
        Getoffersdata && Getoffersdata.length > 0 ? (
          <RunningBanner offers={Getoffersdata} />
        ) : (
          <div></div>
        )
      }
      <div className="body-container">
        {customer ? (
          <>
            <CustomerDashboardCards customer={customer} />
            <div className="Chartsreports">
              <AgingAnalysisCard
                ageingData={ageingData}
                showEmptyGrey={showEmptyGrey}
                EMPTY_DATA={EMPTY_DATA}
                EMPTY_COLOR={EMPTY_COLOR}
                COLORS={COLORS}
                totalValue={totalValue}
                items={items}
              />
              <MonthlyComparisonChart data={GetCustMaster?.yearWiseMonthSales} />
            </div>

          </>
        ) : (<p className="d-flex justify-content-center align-items-center">No customer data available</p>)}
      </div>
      {isLoading() && (
        <div className="loader loaderbg position-absolute">
          <SpinnerLoader />
        </div>
      )}

      <ToastContainer
        position="top-center"
        toastOptions={{
          style: {
            fontSize: '16px',
            padding: '16px',
            width: '400px',
            borderRadius: '8px',
          },
        }}
      />
    </div>
  );

}

export default DashboardTest;

